module.exports = __webpack_public_path__ + "img/zhinengjiaju4.31b0269d.jpg";